var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehousestation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10_\u5E93\u623F\u5DE5\u4F5C\u7AD9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.75,
    y: 23.68,
    width: 32,
    height: 24,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,35.86H42a2,2,0,0,0,2-2v-8a2,2,0,0,0-2-2H22a2,2,0,0,0-2,2v8A2,2,0,0,0,22,35.86Zm2-8H40v4H24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,51.87H42a2,2,0,0,0,2-2v-8a2,2,0,0,0-2-2H22a2,2,0,0,0-2,2v8A2,2,0,0,0,22,51.87Zm2-8H40v4H24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.22,20.13,52,16.7a.69.69,0,0,0,0-.13V10a2,2,0,0,0-2-2H50a2,2,0,0,0-2,2v4.09L33.17,4.3a2,2,0,0,0-1.89-.16,1.85,1.85,0,0,0-.45.21l-24,15.78a2,2,0,0,0,2.2,3.34L12,21.54V54.39C12,57.5,14.24,60,17,60H47c2.76,0,5-2.52,5-5.63V30a2,2,0,1,0-4,0V54.39c0,.93-.53,1.63-1,1.63H17c-.47,0-1-.7-1-1.63V18.91L32,8.35,55,23.47a2,2,0,0,0,2.2-3.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehousestation);
export default __webpack_public_path__ + "static/media/warehousestation.4a01d5d1.svg";
export { ForwardRef as ReactComponent };